import React, { Fragment } from 'react'

const About = () => {
  return (
    <Fragment>
      <h1>About This App</h1>
      <p>React app for searching GitHub users.</p>
    </Fragment>
  )
}

export default About
